<template>
    <div class="sub-top">
        <h4 class="title">
            {{$t('detailComponent.LXXX')}}
        </h4>
        <div class="content-box">
            <div class="content-left-box">
                <div>
                    <el-tag size="mini">
                        {{$t('detailComponent.LXSJ')}}
                    </el-tag>
                    <span class="text">{{ planDto.beginTime }} ——   {{ planDto.endTime }}</span>
                </div>
                <div>
                    <el-tag size="mini">
                        {{$t('detailComponent.LXMS')}}
                    </el-tag>
                    <span class="text">{{ planDto.rule == 1 ? $t('detailComponent.XH'): planDto.rule == 0 ? $t('detailComponent.DC') : '--' }}{{$t('detailComponent.LX')}}</span> <el-divider direction="vertical" v-if="prodIsFree"></el-divider> <span class="text2" v-if="prodIsFree">{{planDto.scoreFlag | filterScoreFlag}}</span> <el-divider direction="vertical" v-if="prodIsFree"></el-divider> <span class="text2" v-if="prodIsFree">{{planDto.answerFlag | filterAnswerFlag}}</span>
                </div>
                <div>
                    <el-tag size="mini">
                        {{$t('detailComponent.LXSJ1')}}
                    </el-tag>
                    <span class="text">{{ planDto.paperName }}</span>
                </div>
                <div class="cpbm">
                    <el-tag size="mini">
                        {{$t('detailComponent.CPBM')}}
                    </el-tag>
                    <span class="text" ref="textCpcode">{{ planDto.planId }}</span>
                    <span class="text copy" :title="$t('detailComponent.FZCPBM')" @click="copyCpcode"></span>
                </div>
            </div>
            <div class="content-right-box">
                <div v-show="planDto.status == 1 ">
                    <div class="img-box">
                        <img src="@/assets/image/chushihua.png"/>
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">{{ lastingStatisDto &&  lastingStatisDto.initDataDto ? lastingStatisDto.initDataDto.numerator : '' }}</span>
                            <span class="total-font">/{{ lastingStatisDto &&  lastingStatisDto.initDataDto ? lastingStatisDto.initDataDto.denominator : '' }}</span>
                        </div>
                        <span class="font-status">
                            {{ 
                                (lastingStatisDto &&  lastingStatisDto.initDataDto ? lastingStatisDto.initDataDto.numerator : '1')
                                ==
                                (lastingStatisDto &&  lastingStatisDto.initDataDto ? lastingStatisDto.initDataDto.denominator : '2' ) ?
                                $t('detailComponent.CSHWC') : $t('detailComponent.CSHZ')
                            }}
                            
                        </span>
                    </div>
                </div>
                <div v-show="planDto.status == 1">
                    <div class="img-box" >
                        <img src="@/assets/image/jiaojuan.png"/>
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">{{ lastingStatisDto && lastingStatisDto.submitDataDto ? lastingStatisDto.submitDataDto.numerator : '' }}</span>
                            <span class="total-font">/{{ lastingStatisDto && lastingStatisDto.submitDataDto ? lastingStatisDto.submitDataDto.denominator : '' }}</span>
                        </div>
                        <span class="font-status">
                            {{$t('detailComponent.JJTD')}}
                        </span>
                    </div>
                </div>
                <div v-show="planDto.status == 1">
                    <div class="img-box">
                        <img src="@/assets/image/startTeam.png"/>
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">{{ lastingStatisDto && lastingStatisDto.waitDataDto ? lastingStatisDto.waitDataDto.numerator : '' }}</span>
                            <span class="total-font">/{{ lastingStatisDto && lastingStatisDto.waitDataDto ? lastingStatisDto.waitDataDto.denominator : '' }}</span>
                        </div>
                        <span class="font-status">
                            {{$t('detailComponent.KSTD')}}
                        </span>
                    </div>
                </div>
                <div v-show="planDto.status == 0">
                    <div class="img-box">
                        <img src="@/assets/image/ing@2x.png"/>
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">{{ pendingStatisDto ? pendingStatisDto.unReadyDataDto.numerator : '' }}</span>
                            <span class="total-font">/{{ pendingStatisDto ? pendingStatisDto.unReadyDataDto.denominator : '' }}</span>
                        </div>
                        <span class="font-status">
                            {{$t('detailComponent.ZJZ')}}
                        </span>
                    </div>
                </div>
                <div v-show="planDto.status == 0 ">
                    <div class="img-box">
                        <img src="@/assets/image/ok@2x.png"/>
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">{{pendingStatisDto ? pendingStatisDto.readyDataDto.numerator : '' }}</span>
                            <span class="total-font">/{{ pendingStatisDto ? pendingStatisDto.readyDataDto.denominator: '' }}</span>
                        </div>
                        <span class="font-status">
                            {{$t('detailComponent.YJX')}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { i18n } from '@/utils/i18n'

export default {
    name: 'topSub',
    props: {
        planDto: {
            type: Object,
            default: ()=>({})
        },
        pendingStatisDto: {
            type: Object,
            default: ()=>({})
        },
        lastingStatisDto: {
            type: Object,
            default: ()=>({})
        }
    },
    computed: {
        prodIsFree() { // 判断是否是免费用户
            return this.__userData.prodIsFree != 1
        }
    },
    methods:{
        copyCpcode(){
            let textarea = document.createElement('textarea');

            textarea.value = this.$refs['textCpcode'].innerHTML;

            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');

            document.body.removeChild(textarea);
            this.$notify({ title: this.$t('detailComponent.FZ'), message: this.$t('detailComponent.FZCG'), duration: 600, type: 'success' });
        }
    },
    filters: {
        filterAnswerFlag: (value)=> { // 开放答案标识  0-关闭 1-交卷开放 2- 单题开放
            let openObj = {
                '0': i18n.t('detailComponent.GBDA'),
                '1': i18n.t('detailComponent.JJKFDA'),
                '2': i18n.t('detailComponent.DTKFDA')
            }
            return openObj[value]
        },
        filterScoreFlag: (value) => { // 开放成绩标识 :  0-关闭 1-开启
            let openObj = {
                '0': i18n.t('detailComponent.GBCJ'),
                '1': i18n.t('detailComponent.KFCJ')
            }
            return openObj[value]
        }
    },
}
</script>
<style lang="scss" scoped>
.sub-top{
    width: 100%;
    height: 185px;
    border-bottom: solid 1px #ccc;
    .title{
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        line-height: 6px;
        color: #0D141E;
        letter-spacing: 1px;
    }
    .content-box{
        display: flex;
        height: 103px;
        width: 100%;
        justify-content: space-between;
        .content-left-box{
            border-right: solid 1px #cccccc;
            flex: 1;
            height: 120px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            
            .text{
                font-size: 14px;
                font-family: Hiragino Sans GB;
                font-weight: normal;
                line-height: 6px;
                color: #5D646E;
                letter-spacing: 1px;
                margin-left: 16px;
            }
            .text2 {
                 font-size: 14px;
                font-family: Hiragino Sans GB;
                font-weight: normal;
                line-height: 6px;
                color: #5D646E;
                letter-spacing: 1px;
            }
            .copy{
                // background: url('~@/assets/image/copy_nor.png');
                display: inline-block;
                width: 16px;
                height: 16px;
                cursor: pointer;
                margin-left: 4px;
            }
            .cpbm:hover{
                .copy{
                    background: url('~@/assets/image/copy_nor.png');
                }
                .copy:hover{
                    background: url('~@/assets/image/copy_hov.png');
                }
            }
        }
        .content-right-box{
            flex: 1;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .img-box{
                width: 64px;
                height: 64px;
                opacity: 0.8;
                img{
                    width: 100%;
                }
            }
            > div{
                display: flex;
                .text-box{
                    margin: -8px 0 0 8px;
                    .font-status, .font-title, .total-font{
                        font-family: Hiragino Sans GB;
                        font-weight: normal;
                    }   
                    .font-title{
                        font-size: 40px;
                        color: #5397F7;
                    }
                    .total-font{
                        font-size: 16px;
                        margin-left: 5px;
                        color: #5D646E;
                    }
                    .font-status{
                        font-size: 14px;
                        color: #5D646E;
                        margin-left: 6px;
                    }
                }
            }
        }
    }
}
</style>